import { useEffect } from "react";
export var useDropdownScroll = function useDropdownScroll(isOpen, containerRef) {
  var dropdownHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 248;
  useEffect(function () {
    if (isOpen && containerRef.current) {
      setTimeout(function () {
        var container = containerRef.current;
        if (!container) return;

        // Find the scrollable parent
        var scrollableParent = container.closest('.overflow-y-auto, .overflow-y-scroll, [class*="scrollbar"]');
        if (scrollableParent) {
          var containerRect = container.getBoundingClientRect();
          var parentRect = scrollableParent.getBoundingClientRect();

          // Check if dropdown would extend below visible area
          var bottomOverflow = containerRect.bottom + dropdownHeight - parentRect.bottom;
          if (bottomOverflow > 0) {
            // Calculate how much to scroll to show the dropdown
            var labelBufferHeight = 20;
            var scrollAmount = Math.max(0, bottomOverflow - labelBufferHeight + 20);

            // Only scroll if necessary and if it won't hide the label completely
            if (scrollAmount > 0) {
              scrollableParent.scrollBy({
                top: scrollAmount,
                behavior: "smooth"
              });
            }
          }
        }
      }, 100);
    }
  }, [isOpen, containerRef, dropdownHeight]);
};
export default useDropdownScroll;